import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    Sotyktu_link: {
        // fontWeight: '600 !important',
        color: '#4933DA !important',
        textDecorationColor: "inherit !important"
    },
    Zeposia_link: {
        color: '#0054A6 !important',
        // lineHeight: '1.35 !important'
        textDecorationColor: "inherit !important"
    },
    Camzyos_link: {
        // fontWeight: '600 !important',
        color: '#0054A6 !important',
        // lineHeight: '1.35 !important'
        textDecorationColor: "inherit !important"
    },
}));

const AdditionalText = (props) => {
    const classes = useStyles();
    return (
        <Box style={{ marginBottom: "20px" }}>
            {props.passname === "Camzyos" &&
                <Typography>Please see <Link className={classes[`${props.passname}_link`]} target="_blank" href="https://packageinserts.bms.com/pi/pi_camzyos.pdf" style={{}}>Full Prescribing Information</Link>, including <strong>Boxed WARNING</strong>, and <Link target="_blank" className={classes[`${props.passname}_link`]} href="https://packageinserts.bms.com/medguide/medguide_camzyos.pdf">Medication Guide</Link> or visit the details section of your wallet.</Typography>
            }
        </Box>
    )
}

export default AdditionalText;